import Raven from 'raven-js';
const LIBRARY_NAME = 'ui-product-approvals';
export const captureException = (error, options = {}) => {
  const err = error instanceof Error ? error : new Error(String(error));
  Raven.captureException(err, Object.assign({}, options, {
    tags: Object.assign({}, options.tags, {
      library_name: LIBRARY_NAME
    })
  }));
};